import type { CreateEstimationRequest, CreateProjectRequest } from '@/api/schema/data-contracts';
import {
  type Actions,
  eActionTypes,
  type EstimationState,
  initEstimationState,
} from '@/context/estimationContext/model.ts';

export const reducer = (state: EstimationState, action: Actions): EstimationState => {
  switch (action.type) {
    case eActionTypes.SET_ESTIMATION:
      return {
        ...state,
        unsavedEstimation: {
          estimation: {
            ...state.unsavedEstimation?.estimation,
            ...action.payload,
          } as CreateEstimationRequest,
          project: { ...state.unsavedEstimation?.project } as CreateProjectRequest,
        },
      };
    case eActionTypes.SET_SELECTED_ESTIMATION_MODEL:
      return {
        ...state,
        selectedEstimationModel: action.payload,
      };
    case eActionTypes.SET_PHASE_RESPONSES:
      return {
        ...state,
        phaseResponses: action.payload,
      };
    case eActionTypes.SET_METHODOLOGIES:
      return {
        ...state,
        methodologiesList: action.payload,
      };
    case eActionTypes.SET_PROJECT:
      if (state.savedEstimation?.estimation.id) {
        return {
          ...state,
          unsavedEstimation: {
            project: {
              ...state.unsavedEstimation?.project,
              ...action.payload,
            } as CreateProjectRequest,
            estimation: { ...state.unsavedEstimation?.estimation } as CreateEstimationRequest,
          },
        };
      }

      return {
        ...state,
        unsavedEstimation: {
          project: {
            ...state.unsavedEstimation?.project,
            ...action.payload,
          } as CreateProjectRequest,
          estimation: { ...state.unsavedEstimation?.estimation } as CreateEstimationRequest,
        },
        selectedEstimationModel: null,
        methodologiesList: [],
      };
    case eActionTypes.SET_SAVED_ESTIMATION:
      return {
        ...state,
        savedEstimation: action.payload,
      };
    case eActionTypes.SET_ESTIMATION_USER_ASSIGNMENTS:
      return {
        ...state,
        estimationUserAssignments: action.payload,
      };
    case eActionTypes.SET_PLANNING_RESPONSIBLE_ID:
      return {
        ...state,
        planningResponsibleId: action.payload,
      };
    case eActionTypes.SET_PROJECT_REVIEWER_ID:
      return {
        ...state,
        projectReviewerId: action.payload,
      };
    case eActionTypes.SET_ADDITIONAL_CONTRIBUTORS:
      return {
        ...state,
        additionalContributorsIds: action.payload,
      };
    case eActionTypes.SET_ADDITIONAL_FIELDS:
      return {
        ...state,
        additionalFields: [
          ...state.additionalFields.filter(
            (field) =>
              !action.payload.some(
                (newField) =>
                  newField.estimationModelAdditionalFieldDefinitionId ===
                  field.estimationModelAdditionalFieldDefinitionId,
              ),
          ),
          ...action.payload,
        ],
      };
    case eActionTypes.REMOVE_ADDITIONAL_FIELD:
      return {
        ...state,
        additionalFields: [
          ...state.additionalFields.filter(
            (field) => field.estimationModelAdditionalFieldDefinitionId !== action.payload,
          ),
        ],
      };
    case eActionTypes.RESET_ESTIMATION_STATE:
      return initEstimationState;
    case eActionTypes.SET_DETAILED_ESTIMATION_ID:
      return {
        ...state,
        detailedEstimationId: action.payload,
      };
    default:
      return state;
  }
};
